import { settings } from '../../../settings/settings-util'
import Renderers from './renderers/renderers'

const reduceReducers = (reducers) =>
{
    return (previous, current) =>
        reducers.reduce(
            (p,r) => r(p, current), previous
        );
};

export default class HeaderToolbar
{
    constructor(passedSettings = null, mutatorModules = [], childComponents = [])
    {
        this._settings = passedSettings || settings;
        this._renderers = new Renderers(this._settings);
        this._mutatorModules = mutatorModules;
        this._childComponents = childComponents;
    }

    static getDefaultSettings()
    {
        return settings;
    }

    getReducer()
    {
        let reducers = [];

        this._childComponents.forEach((item) => {
            reducers.push(item.getReducer());
        });

        return reduceReducers(reducers);
    }

    getRenderer()
    {
        return this._renderers.getRender();
    }

    initialize(store)
    {
        this._mutators = [];
        this._childRenderers = [];

        this._mutatorModules.forEach((item) => {
            this.mutators.push(item.getMutator());
        });

        this._childComponents.forEach((item) => {
            this._childRenderers.push(item.getRenderer());
        });

        this._renderers.initialize(store, this._mutators, this._childRenderers);
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-header-toolbar/src/window-header-toolbar.js